<template>
  <FloatingInput
    v-model="valueModel"
    type="text"
    :label="label"
    :show-valid-icon="validate"
    :error="error"
    :is-dark-floating-label="isDarkFloatingLabel"
    :label-class="labelClass"
    @onFocus="focusHandle"
    @onBlur="blurHandle"
  />
</template>

<script>
import FloatingInput from '@/components/FloatingInput';
import { validateFullName } from '@/utilities/validators';

export default {
  components: {
    FloatingInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Full name',
    },
    labelClass: {
      type: String,
      default: '',
    },
    isDarkFloatingLabel: {
      type: Boolean,
      default: false,
    },
    // pricing form name allows only English letter
    isPricingFormName: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    focusHandle() {
      this.$emit('onFocus');
    },
    blurHandle() {
      this.$emit('onBlur');
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value.trim());
      },
    },
    validate() {
      return validateFullName(this.value, this.isPricingFormName);
    },
  },
};
</script>
